/**
 * Crash guard for i18n.language values that may originate from an external API
 * and be fed into toLocaleString / Intl.NumberFormat / Intl.DateTimeFormat.
 * Returns the fallback "de-DE" when the tag is falsy or malformed.
 */
export function safeLocale(language: string): string {
  if (!language) {
    return "de-DE";
  }
  try {
    Intl.getCanonicalLocales(language);
  } catch {
    return "de-DE";
  }
  return language;
}
